import { UseMutationOptions } from "@tanstack/react-query";
import { fileApi } from "api/File/api.ts";
import { useMutationApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models";

import StoreFileRequest = App.Http.Requests.File.StoreFileRequest;
import StoreFileResponse = App.Http.Responses.File.StoreFileResponse;

// Hook to store a file
export const useStoreFileMutation = (
    options: UseMutationOptions<StoreFileResponse, AxiosError<ApiErrorResponse>, StoreFileRequest | FormData> = {}
) => {
    return useMutationApi<StoreFileResponse, StoreFileRequest | FormData>({
        mutationKey: ["storeFile"],
        mutationFn: (request: StoreFileRequest | FormData) => fileApi.store(request),
        ...options,
    });
};
